import styled from 'styled-components';
import { colorsPalettes } from '@similarweb/styles';

export const Info = styled.p`
    font-size: .875rem;
    color: ${colorsPalettes.carbon[400]};
    width: 60%;
    margin: auto;
`;